export default __webpack_public_path__ + "static/media/Clan Bound Helm of the Golden Horde.3865bcaa.jpg";